import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { CommonService, MessagesService } from 'src/app/services/service.index';

@Injectable({
  providedIn: 'root'
})
export class GraphicGuard implements CanActivate {
  token: any;
  constructor( private authService: AuthService,private _commonServices: CommonService, private _router: Router, private _messagesService: MessagesService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    

    // const sesionData = JSON.parse('' + this._commonServices.getItemsessionStorage("sessionData")).data.user_info.flags.tipousuario
    const validToke=  JSON.parse(sessionStorage.getItem('token'));
if(!validToke){

//   this.token = this.authService.getAuthFromLocalStorage().accessToken;

//   // const sesionData = JSON.parse('' + this._commonServices.getItemsessionStorage("sessionData")).data.user_info.flags.tipousuario
//   const validToke =this.token;
//   // const validToke =  this.token;

// if (!validToke){s

this._router.navigate(['/login']);

return false;
// }
}
    // else if (sesionData !== 'D') {
    //   this._messagesService.error('Error de acceso', 'No cuenta con permisos para esta vista.')
    //   this._router.navigate(['dashboard'])
    //   return false;
    // }
    return true;
  }

}
